import type {
  TLngLat,
  TValuesCurrentBlocks,
  TValuesCurrentPoints,
  TValuesTimeseriesBlocks,
  TValuesTimeseriesPoints,
} from 'App/Map/types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TBlockId, TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'

export const doesPointHaveEmitterType = ({
  propertyId,
  lngLat,
}: {
  propertyId: TPropertyId
  lngLat: TLngLat
}) => {
  const point = fieldAssetStore.getState()?.properties?.[propertyId]?.points?.[lngLat]

  if (!point) return false

  const selectedEmitters = mapControlsStore.getState().selectedEmitters

  if (point.configuration.irrigationEmitterTypesAvailable) {
    return point.configuration.irrigationEmitterTypesAvailable.some((emitter) =>
      selectedEmitters.includes(emitter),
    )
  }

  return false
}

export const doesPointHaveValueType = ({
  propertyId,
  lngLat,
  currentValueToCheck,
  timeseriesValueToCheck,
}: {
  propertyId: TPropertyId
  lngLat: TLngLat
  currentValueToCheck?: TValuesCurrentPoints
  timeseriesValueToCheck?: TValuesTimeseriesPoints
}): boolean => {
  const point = fieldAssetStore.getState()?.properties?.[propertyId]?.points?.[lngLat]

  if (!point) return false

  if (currentValueToCheck) {
    return point.valuesCurrent.includes(currentValueToCheck)
  }

  if (timeseriesValueToCheck) {
    return point.valuesTimeseries.includes(timeseriesValueToCheck)
  }

  return false
}

export const doesBlockHaveValueType = ({
  propertyId,
  blockId,
  currentValueToCheck,
  timeseriesValueToCheck,
}: {
  propertyId: TPropertyId
  blockId: TBlockId
  currentValueToCheck?: TValuesCurrentBlocks
  timeseriesValueToCheck?: TValuesTimeseriesBlocks
}): boolean => {
  const block = fieldAssetStore.getState()?.properties?.[propertyId].blocks?.[blockId]

  if (!block) return false

  if (currentValueToCheck) {
    return block.valuesCurrent.includes(currentValueToCheck)
  }

  if (timeseriesValueToCheck) {
    return block.valuesTimeseries.includes(timeseriesValueToCheck)
  }

  return false
}
